module.exports = __webpack_public_path__ + "img/audio-description-slash.98ef9a99.svg";